class MapContactFieldsUtil {
	static buildInitialOptions = () => ({
		FullNameHeader: {
			id: 'FullNameHeader',
			name: 'Full Name',
			autoMap: ['fullname', 'name'],
			enabled: true,
		},
		FirstNameHeader: {
			id: 'FirstNameHeader',
			name: 'First Name',
			autoMap: ['firstname', 'givenname'],
			enabled: true,
		},
		MiddleNameHeader: {
			id: 'MiddleNameHeader',
			name: 'Middle Name',
			autoMap: ['middlename', 'middleinitial'],
			enabled: true,
		},
		LastNameHeader: {
			id: 'LastNameHeader',
			name: 'Last Name',
			autoMap: ['lastname', 'familyname'],
			enabled: true,
		},
		PrefixHeader: {
			id: 'PrefixHeader',
			name: 'Prefix (Mr., Dr., etc.)',
			autoMap: ['prefix'],
			enabled: true,
		},
		SuffixHeader: {
			id: 'SuffixHeader',
			name: 'Suffix (Jr., MD., etc.)',
			autoMap: ['suffix'],
			enabled: true,
		},
		CompanyHeader: {
			id: 'CompanyHeader',
			name: 'Company',
			autoMap: ['company', 'co', 'organization', 'corporation', 'corporate', 'firm'],
			enabled: true,
		},
		TitleHeader: {
			id: 'TitleHeader',
			name: 'Title',
			autoMap: ['title', 'role'],
			enabled: true,
		},
		DepartmentHeader: {
			id: 'DepartmentHeader',
			name: 'Department',
			autoMap: ['department'],
			enabled: true,
		},
		Street1Header: {
			id: 'Street1Header',
			name: 'Address 1',
			autoMap: ['address', 'address1', 'streetaddress'],
			enabled: true,
		},
		Street2Header: {
			id: 'Street2Header',
			name: 'Address 2',
			autoMap: ['address2', 'building', 'unit'],
			enabled: true,
		},
		Street3Header: {
			id: 'Street3Header',
			name: 'Address 3',
			autoMap: ['address3'],
			enabled: true,
		},
		CityHeader: {
			id: 'CityHeader',
			name: 'City',
			autoMap: ['city'],
			enabled: true,
		},
		StateHeader: {
			id: 'StateHeader',
			name: 'State/Province',
			autoMap: ['state', 'province'],
			enabled: true,
		},
		ZipHeader: {
			id: 'ZipHeader',
			name: 'ZIP/Post. Code',
			autoMap: ['zip', 'zipcode', 'postalcode', 'postcode'],
			enabled: true,
		},
		CountryHeader: {
			id: 'CountryHeader',
			name: 'Country',
			autoMap: ['country', 'nation'],
			enabled: true,
		},
		PhoneHeader: {
			id: 'PhoneHeader',
			name: 'Phone',
			autoMap: ['phone', 'number', 'telephone', 'phonenumber', 'mobile', 'cell'],
			enabled: true,
		},
		PhoneExtensionHeader: {
			id: 'PhoneExtensionHeader',
			name: 'Extension',
			autoMap: ['ext', 'extension'],
			enabled: true,
		},
		EmailHeader: {
			id: 'EmailHeader',
			name: 'Email',
			autoMap: ['email'],
			enabled: true,
		},
		ReferenceHeader: {
			id: 'ReferenceHeader',
			name: 'Reference',
			autoMap: ['reference'],
			enabled: true,
		},
	});

	static buildDefaultMapping = () => ({
		FullNameHeader: '',
		FirstNameHeader: '',
		MiddleNameHeader: '',
		LastNameHeader: '',
		PrefixHeader: '',
		SuffixHeader: '',
		CompanyHeader: '',
		TitleHeader: '',
		DepartmentHeader: '',
		Street1Header: '',
		Street2Header: '',
		Street3Header: '',
		CityHeader: '',
		StateHeader: '',
		ZipHeader: '',
		CountryHeader: '',
		PhoneHeader: '',
		PhoneExtensionHeader: '',
		EmailHeader: '',
		ReferenceHeader: '',
	});

	static buildMappedData = (inputData, rowIndex, prevData) => {
		const columnMappingArray = [];
		const disabledColumnsData = [];
		const initialOptions = [];
		let noOfMappedColumns = 0;
		let isFullNameMapped = false;
		let isOtherNameParamMapped = false;
		const columnData = inputData && inputData[rowIndex] ? inputData[rowIndex] : [];
		const sdcColumnMapping = this.buildDefaultMapping();
		const { columnsMappedData } = prevData || {};
		let index = 0;

		Object.entries(columnData).forEach(([columnName, data]) => {
			let mappedOption = !prevData
				? { id: '-1', enabled: true }
				: columnsMappedData.filter(column => column.columnName === columnName)[0].option;
			let optionIndex = 0;
			const parsedData = data.toLowerCase().replace(/ /g, '');

			Object.entries(this.buildInitialOptions()).forEach(([key, value]) => {
				value.enabled = true;

				if (mappedOption.id === '-1' && value.autoMap.includes(parsedData) && !prevData) {
					value.isMapped = true;
					mappedOption = value;

					if (key === 'FullNameHeader') {
						if (!isFullNameMapped && !isOtherNameParamMapped) {
							isFullNameMapped = true;
						} else if (isOtherNameParamMapped) {
							value.isMapped = false;
							value.enabled = false;
							mappedOption = { id: '-1', enabled: false };
						}
					} else if (
						key.match(
							/^(FirstNameHeader|MiddleNameHeader|LastNameHeader|PrefixHeader|SuffixHeader)$/
						)
					) {
						if (!isFullNameMapped && !isOtherNameParamMapped) {
							isOtherNameParamMapped = true;
						} else if (isFullNameMapped) {
							value.isMapped = false;
							value.enabled = false;
							mappedOption = { id: '-1', enabled: false };
						}
					}
				}

				value.id = key;

				if (initialOptions[optionIndex]) {
					if (value.isMapped) {
						initialOptions[optionIndex] = value;
						initialOptions[optionIndex].isMapped = true;
					}
				} else {
					initialOptions.push(value);
				}

				optionIndex++;
			});

			columnMappingArray.push({
				id: index,
				columnName,
				option: mappedOption,
				isMapped: mappedOption.id !== '-1',
				text: data,
				enabled: mappedOption.enabled,
			});

			if (!mappedOption.enabled) {
				disabledColumnsData.push({
					id: index,
					columnName,
					option: mappedOption,
					isMapped: mappedOption.id !== '-1',
					text: data,
					enabled: mappedOption.enabled,
				});
			}
			if (mappedOption.id !== '-1') {
				sdcColumnMapping[mappedOption.id] = columnName;
				noOfMappedColumns++;
			}

			index++;
			return null;
		});

		columnMappingArray.sort(function(currentColumn, nextColumn) {
			if (
				(currentColumn.isMapped === nextColumn.isMapped && nextColumn.isMapped === true) ||
				(!currentColumn.isMapped && !nextColumn.isMapped)
			) {
				return currentColumn.id < nextColumn.id ? -1 : 0;
			} else if (currentColumn.isMapped && !nextColumn.isMapped) {
				return 1;
			}

			return -1;
		});

		return {
			columnsMappedData: columnMappingArray,
			disabledColumnsData,
			stampsColumnOptions: initialOptions,
			sdcColumnMapping,
			noOfMappedColumns,
			isAllColumnMapped: noOfMappedColumns === columnMappingArray.length,
			isNoColumnMapped: noOfMappedColumns === 0,
			isFewColumnMapped: noOfMappedColumns < columnMappingArray.length,
		};
	};
}

export default MapContactFieldsUtil;
